/**
 * Shared positioning defaults for item-list popups, e.g. Select or Combobox.
 */
export const ITEM_POPUP_POSITIONER_PROPS = {
	align: 'start',
	sideOffset: 8,
	collisionPadding: 12,
} as const;
